import { makeAutoObservable } from 'mobx';

import { Player } from '../model/Player';
import { StateStore } from './StateStore';

class ExpertModeStore implements StateStore {
  private CONTAINER_HEIGHT_COEFFICIENT = 0.7;
  public selectedBot: Player;

  public constructor() {
    makeAutoObservable(this);
  }

  resetState(): void {
    this.selectedBot = null;
  }

  public getSelectedBot = (): Player => this.selectedBot;

  public setSelectedBot = (bot: Player): void => {
    this.selectedBot = bot;
  };

  public getContainerHeightCoefficient = (): number =>
    this.CONTAINER_HEIGHT_COEFFICIENT;
}

const expertModeStore = new ExpertModeStore();
export default expertModeStore;
